module.exports = "https://ssr-releases-cdn.paperlesspost.com/_next/static/pdfs/PP_CCPA_Privacy_Notice_010120.pdf";